import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

interface DeleteConfirmationProps {
  visible: boolean;
  onHide: () => void;
  onDelete: () => void;
  header: string;
  message: string;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  visible,
  onHide,
  onDelete,
  header,
  message,
}) => {
  return (
    <div className="flex justify-content-center">
      <Dialog
        visible={visible}
        breakpoints={{ '960px': '75vw', '640px': '90vw' }}
        style={{ width: '30vw', maxWidth: '90vw' }}
        draggable={false}
        onHide={onHide}
        header={header}
        footer={
          <>
            <Button
              label="Cancel"
              className="p-button-text cancle-btn"
              onClick={onHide}
            />
            <Button
              label={`Remove`}
              className="p-button-danger"
              onClick={onDelete}
            />
          </>
        }
        modal
        closable={false}
      >
        <div>{message}</div>
      </Dialog>
    </div>
  );
};

export default DeleteConfirmation;
